import type { RosterPlayerFormValues } from './types'

/**
 * BE `invalid_fields` snake_case keys → roster form field names for Formik
 * errors. Mirrors the profile modal's map (BE_TO_FORM_FIELD in EditPlayerContext)
 * and adds the roster-only keys. The existing-player `player` message is handled
 * separately (it triggers the link-to-parent condition, not a field error).
 */
export const ROSTER_BE_TO_FORM_FIELD: Record<
  string,
  keyof RosterPlayerFormValues
> = {
  name_first: 'firstName',
  name_last: 'lastName',
  birth_date: 'birthDate',
  height: 'heightFt',
  weight: 'weight',
  email: 'email',
  phone_number: 'phoneNumber',
  alternate_phone_number: 'alternatePhoneNumber',
  preferred_contact_method: 'preferredContactMethod',
  emergency_contact_name: 'emergencyContactName',
  emergency_contact_relationship: 'emergencyContactRelationship',
  emergency_contact_phone_number: 'emergencyContactPhone',
  league_registration_number: 'leagueRegistrationNumber',
  hockey_usa_number: 'hockeyUsaNumber',
  hockey_canada_number: 'hockeyCanadaNumber',
  custom_membership_number: 'customMembershipNumber',
  loyalty_number: 'loyaltyNumber',
  player_number: 'playerNumber',
  player_type_id: 'positionId',
  customer_identifier: 'customerIdentifier',
  // Canlan-only Salesforce ID (hidden on other tenants, so never errors there).
  sf_id: 'salesforceId',
  gender_id: 'genderId',
  'address.street_1': 'addressStreet1',
  'address.street_2': 'addressStreet2',
  'address.city': 'addressCity',
  'address.postal_code': 'addressPostalCode',
  'address.province_id': 'addressProvinceId',
  'address.country_id': 'addressCountryId',
}
